/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import BillBc21Table from "./components/table";
import { useSelector } from "react-redux";
import { authSelector } from "redux/selector";
import { useEffect, useState } from "react";
import { GeneralJournalService } from "services/general-journal";

export default function GeneralJournal() {
  const { formId, formField } = form;
  const { user } = useSelector(authSelector);
  const [company, setCompany] = useState(user?.company || {});

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleSaveTable = async (values, action) => {
    for await (const item of values.valuesTable) {
      const payload = {
        company: company._id.toString(),
        year: values.year,
        recordDate: item.recordDate.value,
        voucherNumber: item.voucherNumber.value,
        voucherDate: item.voucherDate.value,
        description: item.description.value,
        postedToLedger: item.posted.value,
        send: false,
        lines: [
          {
            lineNumber: item.rowIndex.value,
            accountCode: item.offsetAccount.value,
            debit: item.debit.value,
            credit: item.credit.value,
          },
        ],
      };
      const create = await GeneralJournalService.create(payload);
      console.log("Save table values:", create);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box display="flex" flexDirection="column" pb={10} gap={3}>
        <Box textAlign="center">
          <Typography variant="h4" textTransform="uppercase">
            Sổ nhật ký chung
          </Typography>
          <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
            (Ban hành theo Thông tư số 200/2014/TT-BTC ngày 22/12/2014 của Bộ Tài chính)
          </Typography>
        </Box>
        <Formik initialValues={initialValues} validationSchema={validation} onSubmit={handleSubmit}>
          {({ values, errors, touched, isSubmitting, setFieldValue }) => (
            <Form id={formId} autoComplete="off">
              <Fields
                formData={{
                  values,
                  touched,
                  formField,
                  errors,
                }}
              />

              <BillBc21Table
                formData={{
                  values,
                  touched,
                  formField,
                  errors,
                }}
                setFieldValue={setFieldValue}
              />
              <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                  {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                </SoftButton>
                <SoftButton
                  variant="gradient"
                  color="info"
                  type="button"
                  onClick={() => handleSaveTable(values)}
                >
                  Lưu Nháp
                </SoftButton>
              </SoftBox>
            </Form>
          )}
        </Formik>
      </Box>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { taxId, conpanyName, address, unit, year } = formField;
  const { user } = useSelector(authSelector);
  const [company, setCompany] = useState(user?.company || {});
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        {/* <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={sendTo.name}
            label={sendTo.label}
            value={values.sendTo}
            error={errors.sendTo && touched.sendTo}
            success={values.sendTo?.toString().length > 0 && !errors.sendTo}
          />
        </Grid>{" "} */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={conpanyName.name}
            label={conpanyName.label}
            value={company.name || values.conpanyName}
            error={errors.conpanyName && touched.conpanyName}
            disabled={true}
            success={values.conpanyName?.toString().length > 0 && !errors.conpanyName}
          />
        </Grid>{" "}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={company.address || values.address}
            error={errors.address && touched.address}
            disabled={true}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>{" "}
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={unit.name}
            label={unit.label}
            value={values.unit}
            error={errors.unit && touched.unit}
            success={values.unit?.toString().length > 0 && !errors.unit}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={year.name}
            label={year.label}
            value={values.year}
            error={errors.year && touched.year}
            success={values.year?.toString().length > 0 && !errors.year}
          />
        </Grid>
        {/* <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid> */}
      </Grid>
    </Box>
  );
}
